import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSubscriptionTemplateLinkMutation, deleteSubscriptionTemplateLinkMutationVariables } from '../generated/deleteSubscriptionTemplateLinkMutation';
import { subscriptionTemplateLinkFieldsFragment } from '../models/SubscriptionTemplateLink';

/**
 * Get a callback to delete a SubscriptionTemplateLink in the store.
 */
export function useDeleteSubscriptionTemplateLinkCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSubscriptionTemplateLinkMutation, deleteSubscriptionTemplateLinkMutationVariables>(
        gql`
            mutation deleteSubscriptionTemplateLinkMutation ($id: ID!) {
                deleteSubscriptionTemplateLink(id: $id) {
                    ...subscriptionTemplateLinkFields
                }
            }

            ${subscriptionTemplateLinkFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
